import React, { useContext } from "react";
import axiosInstance from "../api/axiosInstance";

import { UserContext, WarehouseContext } from "../storage/context";

import { useNavigate } from "react-router-dom";
import { ADD_USER_PROFILE, REMOVE_USER_PROFILE, REMOVE_WAREHOUSE } from "../storage/reducers/types";

const useProfile = () => {
  const { dispatchUserProfile } = useContext(UserContext);
  const { warehouse, dispatchWarehouse } = useContext(WarehouseContext);
  const navigate = useNavigate();

  // const verifyEmailIfNot = ({ data }) => {
  const verifyEmailIfNot = (response, email = "", password) => {
    if (response.data.email_verified === true) {
      return true;
    } else {
      return navigate("/verification", {
        state: { email, password },
      });
    }
  };

  const setUserProfile = (response) => {
    let { data } = response;
    const userAttributes = {
      token: data.token,
      tokenExpiry: data.token_expiry_at,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      emailVerified: data.email_verified,
      companyName: data.company_name,
    };

    dispatchUserProfile({ type: ADD_USER_PROFILE, payload: userAttributes });
    localStorage.setItem("user", JSON.stringify(userAttributes));
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${userAttributes.token}`;
    // createAxiosInstance(data.token);
  };

  const logoutUserProfile = () => {
    dispatchUserProfile({ type: REMOVE_USER_PROFILE });
    dispatchWarehouse({ type: REMOVE_WAREHOUSE });
    localStorage.removeItem("user");
    localStorage.removeItem("phyllo_analytics");
    localStorage.removeItem("SDK_USER_CREDS");
    localStorage.removeItem("User_Response");
    localStorage.removeItem("currentEnv");
    sessionStorage.removeItem("creatorProfile");
  };

  return { setUserProfile, logoutUserProfile, verifyEmailIfNot };
};

export default useProfile;
